export default (function (props) {
  return {
    eventName: 'Log In Form Displayed',
    flowType: 'proactive',
    platform: 'web',
    product: props.metadata.applicationName,
    reason: props.metadata.userAction
  };
});